import React, { useState } from 'react';
import { AVAILABILITY_OPTIONS } from './availabilityConstants';

const Availability = ({
  CustomSelect,
  SelectWithLabelOption,
  LABELS,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
}) => {
  const [isSelectingEndTime, setIsSelectingEndTime] = useState(false);

  const getFilteredEndOptions = () => {
    if (!startTime) return [];
    const startIndex = AVAILABILITY_OPTIONS.findIndex((option) => option.value === startTime);
    return AVAILABILITY_OPTIONS.slice(startIndex + 1);
  };

  const handleSelect = (value) => {
    if (!isSelectingEndTime) {
      setStartTime(value);
      setIsSelectingEndTime(true);
    } else {
      setEndTime(value);
    }
  };

  return (
    <div className="">
      <CustomSelect
        className="w-full"
        options={isSelectingEndTime ? getFilteredEndOptions() : AVAILABILITY_OPTIONS}
        onSelect={handleSelect}
      >
        <SelectWithLabelOption
          label={isSelectingEndTime ? LABELS[2] : LABELS[2]}
          option={
            startTime && endTime
              ? `${startTime} - ${endTime}`
              : isSelectingEndTime
                ? endTime || 'Select End Time'
                : startTime || 'Select Start Time'
          }
        />
      </CustomSelect>
    </div>
  );
};

export default Availability;
